import Vue from "vue";
import Router from "vue-router";
import routes from "./config";

Vue.use(Router);

const router = new Router({
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path == "/login" || to.path == "/register") {
    next();
  } else {
    /*
    if (localStorage.token) {
      next();
    } else {
      next({
        path: "/login"
      });
    }*/
    next();
  }
});

export default router;
